<template>
    <div
        v-if="isVisible"
        class="cas-promo"
        role="article"
        aria-label="MAX Business"
    >
        <v-avatar :color="maxAvatar.color" size="36" class="pm-ic" aria-hidden="true">
            <v-img
                v-if="maxAvatar.image"
                transition="slide-x-transition"
                :src="maxAvatar.image"
            />
            <span v-else>{{ maxAvatar.symbol }}</span>
        </v-avatar>
        <div class="pm-copy">
            <div class="pm-t">
                MAX Business
                <span class="badge bd-new">Новинка</span>
            </div>
            <div class="pm-d">Канал рассылок без блокировок — главный мессенджер страны. Подключите за 1 день.</div>
        </div>
        <div class="pm-act">
            <button type="button" class="btn-connect" @click.stop="onCtaClick">Подключить</button>
        </div>
    </div>
</template>

<script>
import config from '@root/config'
import { checkIntegrationInstalled } from '@/api/marketplace'
import { CHANNEL_TYPES } from '@root/src/vars/general'

export default {
    name: 'ChannelsSecondChannelPromoBanner',
    props: {
        projectId: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        isVisible: false,
    }),
    computed: {
        connectorsAvatars() {
            return this.$store.state.connectorsAvatars || []
        },
        maxAvatar() {
            return this.connectorsAvatars.find(a => a.type === CHANNEL_TYPES.maxBusiness)
                || this.connectorsAvatars.find(a => a.type === CHANNEL_TYPES.maxChannel)
                || {
                    color: '#fff',
                    symbol: 'MAX',
                    image: '',
                }
        },
    },
    async mounted() {
        const marketplaceId = config.marketplaceModulesIds[config.buildType].maxBusiness
        if (!this.projectId || !marketplaceId) return

        const isInstalled = await checkIntegrationInstalled(this.projectId, marketplaceId)
        this.isVisible = !isInstalled
    },
    methods: {
        onCtaClick() {
            const marketplaceId = config.marketplaceModulesIds[config.buildType].maxBusiness
            if (!this.projectId || !marketplaceId) return
            const targetPath = `/project/${this.projectId}/marketplace/integration/${marketplaceId}`
            const { href } = this.$router.resolve(targetPath)
            window.open(href, '_blank', 'noopener,noreferrer')
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.cas-promo
    margin-top: 14px
    display: flex
    align-items: center
    gap: 14px
    padding: 14px 18px
    border-radius: 16px
    background: linear-gradient(90deg, #F6FBE3, #FBFEEF)
    border: 1px solid #e5e7eb
    font-family: $font-family-base
    cursor: default

.pm-ic
    width: 36px
    height: 36px
    border-radius: 11px !important
    flex-shrink: 0
    overflow: hidden

.pm-copy
    flex: 1
    min-width: 0

.pm-t
    font-family: $font-family-base
    font-size: 13.5px
    line-height: 1.2
    font-weight: 800
    color: $dark-new
    display: flex
    align-items: center
    gap: 9px

.badge
    display: inline-flex
    align-items: center
    gap: 5px
    font-family: $font-family-base
    font-size: 10px
    font-weight: 800
    letter-spacing: .05em
    text-transform: uppercase
    padding: 4px 10px
    border-radius: 999px
    white-space: nowrap

.bd-new
    background: $dark-new
    color: $pop-new

.pm-d
    margin-top: 2px
    color: rgba($dark-new, .56)
    font-size: 12px
    line-height: 1.45

.pm-act
    margin-left: auto

.btn-connect
    display: inline-flex
    align-items: center
    gap: 8px
    border: none
    border-radius: 10px
    padding: 7px 12px
    background: $pop-new
    color: #1A1800
    font-family: $font-family-base
    font-weight: 800
    font-size: 11px
    letter-spacing: .03em
    text-transform: uppercase
    cursor: pointer
    white-space: nowrap
    box-shadow: 0 3px 14px rgba(212, 236, 56, .4)
    transition: filter .15s ease, transform .15s ease

    &:hover
        filter: brightness(.97)
        transform: translateY(-1px)

    &:focus-visible
        outline: 2px solid rgba($main-new, .35)
        outline-offset: 1px

@media (max-width: 820px)
    .cas-promo
        align-items: flex-start
        flex-wrap: wrap

    .pm-copy
        min-width: 100%

    .pm-act
        margin-left: 0
</style>
